export default "__VITE_ASSET__CxBdsFSd__"